import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const applyDirection = useCallback((lng: string) => {
    const dir = lng === 'he' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = lng;
  }, []);

  useEffect(() => {
    applyDirection(i18n.language);
  }, [i18n.language, applyDirection]);

  const toggle = () => {
    const next = i18n.language === 'he' ? 'en' : 'he';
    i18n.changeLanguage(next);
    applyDirection(next);
  };

  return (
    <button
      onClick={toggle}
      className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 transition-colors"
      aria-label="Switch language"
    >
      🌐 {i18n.language === 'he' ? 'EN' : 'עב'}
    </button>
  );
}
